module.exports = __webpack_public_path__ + "static/media/404.3f5ffae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/404.jpg
// module id = 1841
// module chunks = 6